module.exports = {"HAS_REMOTE_ID":false,"TEXT_COLOR":"#AB8439"}


//////////////////
// WEBPACK FOOTER
// ./src/plugins/tfs/platformConfigs/theme/storeSelection.json
// module id = 1367
// module chunks = 1